import { render } from "./arrangeQuestion.vue?vue&type=template&id=02fc6b2c&scoped=true"
import script from "./arrangeQuestion.vue?vue&type=script&lang=js"
export * from "./arrangeQuestion.vue?vue&type=script&lang=js"

import "./arrangeQuestion.vue?vue&type=style&index=0&id=02fc6b2c&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fc6b2c"]])

export default __exports__